import { ExtensionCodec, decode } from "@msgpack/msgpack";
//#region src/api/orpc/util/msgpack.ts
const BIGINT_EXT_TYPE = 0;
const extensionCodec = new ExtensionCodec();
extensionCodec.register({
	type: BIGINT_EXT_TYPE,
	encode: () => null,
	decode(data) {
		return new DataView(data.buffer, data.byteOffset, data.byteLength).getBigUint64(0, false);
	}
});
const base64ToBytes = (b64) => {
	const binary = atob(b64);
	const bytes = new Uint8Array(binary.length);
	for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
	return bytes;
};
const decodeBase64Msgpack = (b64) => decode(base64ToBytes(b64), { extensionCodec });
//#endregion
export { decodeBase64Msgpack };
